import React from 'react';
import Slider, { Settings } from 'react-slick';

type BizCarouselSettings = {
	arrows?: boolean;
	autoplay?: boolean;
	dots?: boolean;
	infinite?: boolean;
	slidesToScroll?: number;
	slidesToShow?: number;
	centerMode?: boolean;
	centerPadding?: string;
};

type BizCarouselProps = {
	children: React.ReactNode;
	settings?: BizCarouselSettings;
};

const BizCarousel = ({ settings, children }: BizCarouselProps) => {
	//dont use slick settings directly in case we want to change component
	const slickSettings: Settings = {
		...settings,
	};

	return (
		<div>
			<Slider {...slickSettings}>{children}</Slider>
		</div>
	);
};

export default BizCarousel;
